/**
 * LoadMoreButton — shared "Load more" pager control for cursor-paginated lists.
 *
 * Renders nothing when `hasMore` is false. Shows an inline spinner and disables
 * itself while `loading` is true. Pass an explicit `label` to customize copy.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './LoadMoreButton.css';

export function LoadMoreButton({
  hasMore,
  loading = false,
  onClick,
  label = 'Load more',
  loadingLabel = 'Loading…',
  className = '',
  ...rest
}) {
  if (!hasMore) return null;
  const cls = ['load-more-btn', loading && 'is-loading', className]
    .filter(Boolean)
    .join(' ');
  return (
    <div className="load-more-wrap">
      <button
        type="button"
        className={cls}
        onClick={onClick}
        disabled={loading}
        {...rest}
      >
        {loading ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin /> {loadingLabel}
          </>
        ) : (
          label
        )}
      </button>
    </div>
  );
}

export default LoadMoreButton;
